import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    Sentry.withScope((scope) => {
      scope.setContext('vue', {
        componentName: instance?.$options.name || 'Unknown',
        propsData: instance?.$props,
        lifecycle: info
      })
      scope.setLevel('error')
      Sentry.captureException(error)
    })
  }

  if (import.meta.client) {
    window.addEventListener('unhandledrejection', (event) => {
      Sentry.withScope((scope) => {
        scope.setContext('promise_rejection', {
          reason: event.reason,
          promise: event.promise
        })
        scope.setLevel('warning')
        Sentry.captureException(new Error(event.reason))
      })
    })
  }
})
